<template>
  <div class="boxbgcolor weixin-api-configure">
    <!--左侧树形展示所有停车场-->
    <div class="left content-left">
      <AllTree v-on:handleTreeClick="handleTreeClick"></AllTree>
    </div>
    <div class="right content-right configure-right">
      <div class="content-right-left">
        <el-form label-width="200px" :rules="rules" :model="payConfigure" ref="addOrEditForm">
          <el-form-item label="微信公众号名称" prop="systemname">
            <el-input v-model="payConfigure.systemname" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item label="微信开发者AppId" prop="appid">
            <el-input v-model="payConfigure.appid" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>

          <el-form-item label="微信开发者apikey" prop="apikey">
            <el-input v-model="payConfigure.apikey" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item label="微信开发者AppSecret" prop="secret">
            <el-input v-model="payConfigure.secret" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item label="商户号" prop="mchid">
            <el-input v-model="payConfigure.mchid" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item label="子商户号">
            <el-input v-model="payConfigure.subMchId" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item prop="openFlag">
            <el-checkbox v-model="payConfigure.openFlag" label="是否启用" name></el-checkbox>
          </el-form-item>
        </el-form>
        <div class="submit">
          <el-button type="primary" size="medium" @click="addOrEdit">提交</el-button>
        </div>
      </div>
      <div class="content-right-right">
        <div class="content-right-right-inner">
          <div class="upload">
            <el-upload
              list-type="text"
              action="/api/parking/wechatJsapi/upload"
              multiple
              :limit="3"
              :headers="headers"
              :on-error="uploadError"
              :on-success="uploadSuccess"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
          <div class="upload-tip">txt文件，公众号提交基础配置时获取,只需要上传一次</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { weixinPayConfigureOne, weixinPayConfigureAddOrEdit } from "@/api/url";

import AllTree from "@/page/commons/allTree";

import Cookies from "js-cookie";
export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      fileList: [],
      payConfigure: {
        id: "",
        systemname: "",
        appid: "",
        mchid: "",
        apikey: "",
        secret: "",
        openFlag: false,
        subMchId: "",
      },
      headers: {
        Authorization: Cookies.get("Authorization"), //从cookie里获取token，并赋值  Authorization ，而不是token
      },
      rules: {
        configureTxt: [
          { required: true, message: "请上传验证文件", trigger: "blur" },
        ],
        systemname: [
          { required: true, message: "请填写微信公众号名称", trigger: "blur" },
        ],
        appid: [
          { required: true, message: "请填写微信开发者AppId", trigger: "blur" },
        ],
        secret: [
          {
            required: true,
            message: "请填写微信开发者AppSecret",
            trigger: "blur",
          },
        ],
        apikey: [
          {
            required: true,
            message: "请填写微信开发者apikey",
            trigger: "blur",
          },
        ],
        // mchid: [{ required: true, message: "请填写商户号", trigger: "blur" }],
        // openFlag: [
        //     { required: true, message: '请填写微信公众号名称', trigger: 'blur' }
        // ]
      },
    };
  },
  methods: {
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.resetForm();
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.payConfigureOne();
      } else {
        this.payConfigure.systemname = "";
        this.payConfigure.id = "";
        this.payConfigure.appid = "";
        this.payConfigure.mchid = "";
        this.payConfigure.subMchId = "";
        this.payConfigure.apikey = "";
        this.payConfigure.secret = "";
        this.payConfigure.openFlag = false;

        // this.$message({
        //     message: '请选择车场！',
        //     type: 'warning'
        // });
      }
      // if(node.level==2){
      // 	this.treeData.parkingId=data.parent.data.id;
      // 	this.treeData.areaId=node.id;
      // }
    },
    payConfigureOne() {
      this.$postRequest(weixinPayConfigureOne(), {
        parkingId: this.treeData.parkingId,
      }).then((data) => {
        if (data.data) {
          this.treeData.parkingId = data.data.parkingId;
          this.payConfigure.systemname = data.data.systemname;
          this.payConfigure.id = data.data.id;
          this.payConfigure.appid = data.data.appid;
          this.payConfigure.mchid = data.data.mchid;
          this.payConfigure.subMchId = data.data.subMchId;
          this.payConfigure.apikey = data.data.apikey;
          this.payConfigure.secret = data.data.secret;
          this.payConfigure.openFlag = data.data.openFlag == "y" ? true : false;
        } else {
          // this.treeData.parkingId='';
          this.payConfigure.systemname = "";
          this.payConfigure.id = "";
          this.payConfigure.appid = "";
          this.payConfigure.mchid = "";
          this.payConfigure.subMchId = "";
          this.payConfigure.apikey = "";
          this.payConfigure.secret = "";
          this.payConfigure.openFlag = false;
        }
      });
      // console.log(this.payConfigure.openflag)
    },
    addOrEdit() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
        return;
      }
      this.$refs.addOrEditForm.validate((valid) => {
        if (valid) {
          this.$postRequest(weixinPayConfigureAddOrEdit(), {
            id: this.payConfigure.id,
            parkingId: this.treeData.parkingId,
            systemname: this.payConfigure.systemname,
            appid: this.payConfigure.appid,
            mchid: this.payConfigure.mchid,
            subMchId: this.payConfigure.subMchId,
            apikey: this.payConfigure.apikey,
            secret: this.payConfigure.secret,
            openFlag: this.payConfigure.openFlag ? "y" : "n",
          }).then((data) => {
            //提交后的操作
            if (data.status != 200) return this.$layer.msg(data.message);
            this.$notify({
              type: "success",
              title: "成功",
              message: "新增或修改配置成功!",
            });
          });
        } else {
          console.log(this.errors.all());
        }
      });
    },
    uploadError() {
      this.$notify({
        type: "error",
        title: "上传失败",
        message: "请检查文件类型,重新上传!",
      });
    },
    uploadSuccess() {
      this.$notify({
        type: "success",
        title: "成功",
        message: "文件上传成功!",
      });
    },
    isParkingIdEmpty() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
      }
    },
    resetForm() {
      this.$refs["addOrEditForm"].resetFields();
    },
  },
  computed: {},
  components: {
    AllTree,
  },

  mounted: function () {},
};
</script>

<style scoped>
.submit {
  text-align: center;
}
.configure-right {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content-right-right {
  width: 40%;
  height: 100%;
  margin: 0 1%;
}
.content-right-left {
  width: 60%;
  height: 100%;
  margin-right: 20px;
}
.content-right-right .upload {
  border: 2px dotted #ddd;
  border-radius: 10px;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-right-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-right-right-inner {
  height: 60%;
}
.upload-tip {
  color: red;
  margin-top: 10px;
  text-align: center;
}
</style>
<style>
.weixin-api-configure .content-right .el-input__inner {
  border-radius: 5px;
  height: 45px;
  line-height: 45px;
}
.weixin-api-configure .el-form-item {
  margin-bottom: 20px;
}
.weixin-api-configure .el-form-item__label {
  height: 45px;
  line-height: 45px;
  color: #333 !important;
  font-weight: bold;
}
.weixin-api-configure .submit .el-button {
  width: 200px;
  height: 50px;
}
.weixin-api-configure .el-checkbox__label {
  color: #333 !important;
  font-weight: bold;
}
.weixin-api-configure .el-upload__tip {
  height: 30px;
  line-height: 30px;
}
.weixin-api-configure .el-upload__tip {
  color: red !important;
}
.weixin-api-configure .el-upload,
.weixin-api-configure .el-upload-list {
  float: none !important;
  display: block;
}
</style>